import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { id: "cases-grid-wrapper" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { colspan: "1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "1" }
const _hoisted_13 = ["data-tissue", "data-case-id", "title"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_IbIcons = _resolveComponent("IbIcons")!
  const _component_dropdownlist = _resolveComponent("dropdownlist")!
  const _component_ILabel = _resolveComponent("ILabel")!
  const _component_Grid = _resolveComponent("Grid")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_i_dialog = _resolveComponent("i-dialog")!

  return (!_ctx.isDirectLink)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "cases_panel",
        class: _normalizeClass(["clear_all_widgets_on_click", { 'with-slides': _ctx.selectedID }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_k_input, {
              onInput: _ctx.searchFilter,
              placeholder: _ctx.t('cases_list.filter_placeholder'),
              defaultValue: '',
              type: "search",
              size: "large",
              "icon-name": 'search',
              incremental: ""
            }, null, 8, ["onInput", "placeholder"])
          ]),
          _createVNode(_component_Grid, {
            "data-items": _ctx.result,
            pageable: true,
            skip: _ctx.skip,
            take: _ctx.take,
            total: _ctx.total,
            columns: _ctx.columns,
            sortable: { allowUnsort: false },
            sort: _ctx.sort,
            "selected-field": _ctx.selectedField,
            onSortchange: _ctx.sortChangeHandler,
            onPagechange: _ctx.pageChangeHandler,
            onCellclick: _ctx.onCellClick,
            onFilterchange: _ctx.filterChange
          }, {
            complete: _withCtx(({ props }) => [
              _createElementVNode("td", {
                colspan: "1",
                onClick: ($event: any) => (_ctx.onCellClick(props)),
                class: "fs-0 col-complete"
              }, [
                (_ctx.isCompleted(props.dataItem))
                  ? (_openBlock(), _createBlock(_component_IbIcons, {
                      key: 0,
                      icon: "v_green_circle",
                      title: _ctx.t('cases_list.completed')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_3)
            ]),
            technical: _withCtx(({ props }) => [
              _createElementVNode("td", {
                colspan: "1",
                onClick: ($event: any) => (_ctx.onCellClick(props)),
                class: "fs-0 technical"
              }, [
                (_ctx.isTechnical(props.dataItem))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_IbIcons, {
                        icon: "exclamation_mark_grey_circle",
                        title: _ctx.t('cases_list.technical'),
                        class: "icon icon-non-selected"
                      }, null, 8, ["title"]),
                      _createVNode(_component_IbIcons, {
                        icon: "exclamation_mark_white_circle",
                        title: _ctx.t('cases_list.technical'),
                        class: "icon icon-selected"
                      }, null, 8, ["title"])
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4)
            ]),
            assignTo: _withCtx(({ props }) => [
              _createElementVNode("td", _hoisted_6, [
                (_openBlock(), _createBlock(_component_dropdownlist, {
                  key: props.dataItem.caseId + props.dataItem.assignedTo,
                  "data-items": _ctx.state.globals.usernames_list,
                  "default-value": props.dataItem.assignedTo,
                  style: _normalizeStyle({
                height: '34px',
                border: 'none',
                borderRadius: '7px',
                backgroundColor: 'var(--white)',
                backgroundImage: 'none',
                flex: 'auto'
              }),
                  popupSettings: {
                className: 'ib-drop-downs',
                height: '600px'
              },
                  icon: "chevron-down",
                  onChange: _ctx.reassign
                }, null, 8, ["data-items", "default-value", "style", "onChange"]))
              ])
            ]),
            alerts: _withCtx(({ props }) => [
              _createElementVNode("td", {
                colspan: "1",
                onClick: ($event: any) => (_ctx.onCellClick(props))
              }, [
                (props.dataItem.alerts.clinical)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: _ctx.AlertType.CLINICAL,
                      class: "alert-label clinical",
                      title: _ctx.t('cases_list.clinical')
                    }, _toDisplayString(props.dataItem.alerts.clinical), 9, _hoisted_8))
                  : _createCommentVNode("", true),
                (props.dataItem.alerts.technical)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: _ctx.AlertType.TECHNICAL,
                      class: "alert-label technical",
                      title: _ctx.t('cases_list.technical')
                    }, _toDisplayString(props.dataItem.alerts.technical), 9, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_7)
            ]),
            caseLabels: _withCtx(({ props }) => [
              _createElementVNode("td", {
                onClick: ($event: any) => (_ctx.onCellClick(props))
              }, [
                (props.dataItem.caseLabels?.labels)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.caseLabels.labels, (label, index) => {
                        return (_openBlock(), _createBlock(_component_ILabel, {
                          key: index,
                          "label-key": label.key,
                          likelihood: label.likelihood,
                          title: _ctx.t(`config.insight.labels.${props.dataItem.tissue}.${label.key}.title`),
                          size: 16
                        }, null, 8, ["label-key", "likelihood", "title"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_10)
            ]),
            diagnosis: _withCtx(({ props }) => [
              _createElementVNode("td", _hoisted_12, [
                (_ctx.enableDiagnosis(props.dataItem.diagnosis, props.dataItem.isDiagnosed))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      "data-tissue": props.dataItem.tissue,
                      "data-case-id": props.dataItem.caseId,
                      title: _ctx.t('cases_list.add_diagnosis'),
                      class: "k-button set-diagnosis",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDiagnosis && _ctx.addDiagnosis(...args)))
                    }, _toDisplayString(_ctx.t("cases_list.add_diagnosis")), 9, _hoisted_13))
                  : _createCommentVNode("", true),
                (!_ctx.enableDiagnosis(props.dataItem.diagnosis, props.dataItem.isDiagnosed))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onCellClick(props))
                    }, _toDisplayString(props.dataItem.diagnosis), 9, _hoisted_14))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["data-items", "skip", "take", "total", "columns", "sort", "selected-field", "onSortchange", "onPagechange", "onCellclick", "onFilterchange"])
        ])
      ], 2))
    : (_ctx.errorModal)
      ? (_openBlock(), _createBlock(_component_i_dialog, {
          key: 1,
          title: _ctx.t(`cases_error_modal.header`),
          type: _ctx.modalTypes.ERROR,
          closeIcon: false
        }, {
          body: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              tag: "p",
              keypath: "cases_error_modal.body"
            }, {
              newline: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "type"]))
      : _createCommentVNode("", true)
}